import { useTRPCAPI, useTRPCQuery } from '../../../../trpc/trpc';
import type { ProofOptions } from '../outreachTypes';

/** `outreach.campaigns.proofOptions`: the numbers that the artist may show as proof (the Message step). */
export function useProofOptions(accountId: number, campaignUuid: string) {
  const trpcAPI = useTRPCAPI();
  const query = useTRPCQuery(
    trpcAPI.outreach.campaigns.proofOptions.queryOptions({ accountId, campaignUuid }, { retry: false })
  );
  return { proof: (query.data as ProofOptions | undefined) ?? null, isLoading: query.isLoading };
}
